import React, { useState } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import BorrowerOfferTab from "./BorrowerOfferTab";
import BorrowerLoansTab from "./BorrowerLoansTab";
import BorrowerListingTab from "./BorrowerListingTab";

const BorrowTab = () => {
  const [tabsActive, setTabsActive] = useState(1);
  const tabsHeadText = [
    {
      id: 1,
      text: "Listings",
      icon: "offers",
    },
    {
      id: 2,
      text: "Offers",
      icon: "offers",
    },
    {
      id: 3,
      text: "Loans",
      icon: "offers",
    },
  ];

  return (
    <div className="scrollbar-custom mt-14 overflow-x-auto rounded-lg">
      {/* <!-- Tabs Nav --> */}
      <Tabs className="min-w-fit tabs grid grid-cols-1 md:grid-cols-12">
        <TabList className="nav nav-tabs flex items-center md:block md:col-span-3 mb-3 md:mb-0">
          {/* <!-- Offers --> */}
          {tabsHeadText.map(({ id, text, icon }) => {
            return (
              <Tab
                className="nav-item bg-transparent px-2 bg-jacarta-200"
                key={id}
              >
                <button
                  className={`${
                    tabsActive === id
                      ? "bg-jacarta-500 !text-[#fff] rounded-lg"
                      : ""
                  } nav-link hover:text-jacarta-700 w-full text-jacarta-400 relative flex items-center whitespace-nowrap py-3 px-6 dark:hover:text-white`}
                  onClick={() => setTabsActive(id)}
                >
                  <span className="font-display text-base text-left font-medium w-full">
                    {text}
                  </span>
                </button>
              </Tab>
            );
          })}
        </TabList>
        <div className="md:col-span-9">
          <TabPanel className="tab-content">
            <BorrowerListingTab />
          </TabPanel>
          <TabPanel className="tab-content">
            <BorrowerOfferTab />
          </TabPanel>
          <TabPanel>
            <BorrowerLoansTab />
          </TabPanel>
        </div>
      </Tabs>
    </div>
  );
};

export default BorrowTab;
